<div class="ui-g">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <div class="pagehd ml-2 ui-g-12">Partner Email Allow List</div>

  <div class="m-4">
    <strong>Note before adding User Email and Partner ID to Allow List</strong>
    <ul>
      <li>
        Troubleshoot the standard steps with partner before adding to email
        allow list.
      </li>
      <li>Verify the Email and Partner ID are related and valid.</li>
    </ul>
  </div>

  <div class="ui-g-12 ml-4 mr-4 pt-4">
    <div class="search-box mr-2">
      <input
        type="text"
        pInputText
        size="30"
        placeholder="Search"
        (input)="searchEmailAllowedList()"
        style="width: 340px"
        [(ngModel)]="searchInput" />
      @if (searchInput) {
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-times"
          (click)="clearSearchText()"
          class="close-button p-button-rounded p-button-text p-0">
          Clear
        </button>
      }
    </div>
    <p-button
      class="add-button btn-upload ui-state-default ui-button-info"
      (click)="showAddAllowListUserDialog()">
      Add Email To Allow List
    </p-button>
  </div>
  @if (!loading) {
    <div class="ui-g-12 ml-4 mr-4">
      @if (!hasAllowListUsers) {
        <div class="placeholder-container">
          <div class="placeholder-content">No Users added to Allow List.</div>
        </div>
      }
      @if (hasAllowListUsers) {
        <div>
          <p-table
            #dt
            [columns]="scrollableCols"
            [value]="emailAllowList"
            selectionMode="single"
            [loadingIcon]="loadingIcon"
            [showLoader]="true"
            [scrollable]="true"
            [style]="{ width: '100%' }"
            scrollHeight="550px"
            dataKey="m365eventId"
            [paginator]="true"
            [rows]="10"
            [pageLinks]="5"
            paginatorPosition="top"
            (onPage)="pageChange($event)"
            class="table"
            [first]="first">
            <ng-template #header let-columns>
              <tr class="row">
                <th class="colsmall">Email</th>
                <th class="colsmall">Full Name</th>
                <th class="collarge">PartnerID</th>
                <th class="colmedium">Modified On</th>
                <th class="colmedium">Modified By</th>
                <th class="colmedium">Active</th>
                <th class="colmedium">Activate/Deactivate</th>
              </tr>
            </ng-template>
            <ng-template #body let-rowData let-columns="columns">
              <tr class="row">
                <td
                  class="collarge"
                  tooltipPosition="top"
                  pTooltip="{{ rowData.primaryEmail }}">
                  <span class="wrap-text">{{ rowData.primaryEmail }}</span>
                </td>
                <td class="colsmall">
                  <span class="wrap-text">{{ rowData.fullName }}</span>
                </td>
                <td class="colsmall">
                  <span class="wrap-text">{{ rowData.mpnId }}</span>
                </td>
                <td class="colsmall">
                  <span class="wrap-text">{{
                    rowData.modifiedOn !== null && rowData.modifiedOn
                      | date: 'MM/dd/yyyy'
                  }}</span>
                </td>
                <td
                  class="colmedium"
                  tooltipPosition="top"
                  pTooltip="{{
                    rowData.modifiedBy === null
                      ? ''
                      : rowData.modifiedBy.fullName
                  }}">
                  @if (rowData.modifiedBy) {
                    <span class="wrap-text">{{
                      rowData.modifiedBy.fullName
                    }}</span>
                  }
                </td>
                <td class="colsmall">
                  <span>{{ rowData.isActive ? 'YES' : 'NO' }}</span>
                </td>
                <td class="colsmall">
                  <p-button (click)="updateAllowListStatus(rowData)">
                    @if (!rowData.isActive) {
                      Activate
                    }
                    @if (rowData.isActive) {
                      Deactivate
                    }
                  </p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  }
  <app-add-allow-list-user
    #addAllowListUserModal
    (reload)="onReload()"></app-add-allow-list-user>
</div>
